/* FBF November 2026 tiers: live line in the product-page tier box. Reads /cart.js only, never writes to the cart. Same logic as Heny's heny-tier-pdp.js. */
(function () {
  if (window.__fbfNtTier) return;
  window.__fbfNtTier = true;
  var cartBase = null;
  function tierOf(sum) { return sum >= 100000 ? 10 : sum >= 80000 ? 7 : sum >= 50000 ? 5 : 0; }
  function nextOf(sum) { return sum < 50000 ? [50000, 5] : sum < 80000 ? [80000, 7] : sum < 100000 ? [100000, 10] : null; }
  function shekels(agorot) { return Math.ceil(agorot / 100).toLocaleString('he-IL'); }
  function selection(box) {
    var map = {};
    try { map = JSON.parse(box.getAttribute('data-variants') || '{}'); } catch (e) { map = {}; }
    var fid = box.getAttribute('data-form');
    var form = fid ? document.getElementById(fid) : null;
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var price = idInput && map[idInput.value] != null ? map[idInput.value] : parseInt(box.getAttribute('data-price'), 10) || 0;
    var qtyInput = (form && form.querySelector('[name="quantity"]')) || (fid && document.querySelector('[name="quantity"][form="' + fid + '"]'));
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    return price * qty;
  }
  function render() {
    if (cartBase === null) return;
    var boxes = document.querySelectorAll('[data-fbf-nt-tier]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i], en = box.getAttribute('data-en') === '1';
      var sum = cartBase + selection(box), cur = tierOf(sum), next = nextOf(sum);
      var cards = box.querySelectorAll('.fbf-nt-tier__card');
      for (var j = 0; j < cards.length; j++) cards[j].classList.toggle('is-on', parseInt(cards[j].getAttribute('data-p'), 10) === cur);
      var line = box.querySelector('[data-fbf-nt-line]');
      if (!line) continue;
      if (en) line.innerHTML = next ? '<b>' + shekels(next[0] - sum) + ' ILS</b> more for <b>' + next[1] + '% off</b>' : '<b>You get 10% off</b>';
      else line.innerHTML = next ? 'עוד <b>' + shekels(next[0] - sum) + ' ₪</b> ל-<b>' + next[1] + '% הנחה</b>' : '<b>קיבלת 10% הנחה</b>';
    }
  }
  function later(fn, ms) { setTimeout(fn, ms); }
  function load() {
    if (!document.querySelector('[data-fbf-nt-tier]')) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartBase = (c && c.original_total_price) || 0; render(); })
      .catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && (t.name === 'quantity' || t.name === 'id' || (t.closest && t.closest('form, variant-picker, quantity-selector')))) later(render, 80);
  });
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') later(render, 80); });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-picker, quantity-selector, [class*="quantity"], .variant-picker')) later(render, 150);
  });
  document.addEventListener('variant:change', function () { later(render, 100); });
  document.addEventListener('cart:change', function () { later(load, 400); });
  document.addEventListener('cart:refresh', function () { later(load, 400); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
